// extracted by mini-css-extract-plugin
module.exports = {"container":"ChangeAuthorModale_container__2Scli"};